<template>
  <div class="cancelForm">
    <!-- <form action> -->
	<v-form v-model="valid" ref="form" onsubmit="return false;">
		<fieldset>
      <div class="inputBox">
        <p>해지를 위해서는 가입자 확인이 필요합니다.</p>
        <div class="inputList">
          <div>
            <input type="text" onKeyup="this.value=this.value.replace(/[^0-9]/g,'');" v-model="cellTelNo" placeholder="휴대폰번호('-'제외)" maxlength="11" />
          </div>
        </div>
      </div>
      <div class="sendMsg">
        <button type="button" @click.stop="sendSmsCert"
		:data-ga-category="gaEvent.category.extSgKt.termi.name" :data-ga-label="gaEvent.category.extSgKt.termi.label1" :data-ga-action="gaEvent.actions.buttonClick"
		>인증번호 전송</button>
      </div>

      <div class="confirmInput">
        <div class="inputWrap">
          <input type="text" onKeyup="this.value=this.value.replace(/[^0-9]/g,'');" v-model="certNum" maxlength="5" />
          <div class="timer">
            <!-- <span>{{timeValue}}</span> -->
            <span>{{countdown}}</span>
          </div>
        </div>
      </div>

      <div class="btnArea">
        <div class="leftBox">
          <a @click.stop="goReturn"
		  :data-ga-category="gaEvent.category.extSgKt.termi.name" :data-ga-label="gaEvent.category.extSgKt.termi.label2" :data-ga-action="gaEvent.actions.buttonClick"
		  >취소</a>
        </div>
        <div class="rightBtn">
          <button @click.stop="submit"
		  :data-ga-category="gaEvent.category.extSgKt.termi.name" :data-ga-label="gaEvent.category.extSgKt.termi.label3" :data-ga-action="gaEvent.actions.buttonClick"
		  >세이프가드 해지</button>
        </div>
      </div>
      <div class="infoText">
        <p>* 해지 시 해당월 이용내역에 대해서는 일할 계산되어 청구됩니다.</p>
      </div>
		</fieldset>
    <!-- </form> -->
	</v-form>
	<!-- 처리 프로그레스 시작-->
    <v-layout row justify-center>
      <v-dialog v-model="progressDialog" persistent max-width="100" > 
        <v-card>
          <v-progress-linear color="#0046dc" :indeterminate="true" style="margin:auto 0px; color:red;"></v-progress-linear>
          <!-- </div> -->
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- 처리 프로그레스 끝-->
	<!-- 팝업 시작-->
    <v-layout row justify-center>
      <v-dialog v-model="resultDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline"></v-card-title>
          <v-card-text style="text-align:center; font-size: 90%;" v-html="resultDialogText"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click.native="closePopup"
			:data-ga-category="gaEvent.category.extSgKt.termi.name" :data-ga-label="gaEvent.category.extSgKt.termi.label4" :data-ga-action="gaEvent.actions.buttonClick"
			>확인</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- 팝업 끝-->
	<!-- 오류 팝업 시작-->
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline"></v-card-title>
          <v-card-text style="text-align:center;">{{dialogText}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click.native="closePopup"
			:data-ga-category="gaEvent.category.extSgKt.termi.name" :data-ga-label="gaEvent.category.extSgKt.termi.label4" :data-ga-action="gaEvent.actions.buttonClick"
			>확인</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- 오류 팝업 끝-->
	<!-- html 오류 팝업 시작-->
    <v-layout row justify-center>
      <v-dialog v-model="dialogHtml" persistent max-width="310">
        <v-card>
          <v-card-title class="headline"></v-card-title>
          <v-card-text style="text-align:center;" v-html="dialogHtmlText"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="green darken-1" text @click.native="dialogHtml = false">확인</v-btn> -->
            <v-btn color="green darken-1" text @click.native="closePopup"
			:data-ga-category="gaEvent.category.extSgKt.termi.name" :data-ga-label="gaEvent.category.extSgKt.termi.label4" :data-ga-action="gaEvent.actions.buttonClick"
			>확인</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- html 오류 팝업 끝-->
  </div>
</template>

<script>
import {GaTracking} from "@/mixins/index.js";
import { CONSTANS } from '@/const/index.js';


export default {
  mixins: [GaTracking],
	data() {
		return {
			type: "termination",
			valid: false,
			teleCoCd: "2", //통신사구분코드
			name: "", // 이름
			birth: "", // 생년월일
			genCd: "", // 성별코드
			cellTelNo: "", // 전화번호
			userGender: 1,
			prdtNo: "A003",
			chanCd: "F103",
			certNum: '',
			//timer
			countdown: "3:00",
			endTime: "",
			hours: "",
			mins: "",
			msLeft: "",
			time: "",
			// dialog
			dialog: false,
			dialogText: "",
			dialogHtml: false,
			dialogHtmlText: "",

			resultDialog: false,
			resultDialogText: "",
			progressDialog: false,
			timeValue: '3:00',
			
			userName: '',
			userBirth: '',
			userPhone: '',
			nextRouteName: "",
			backRouteName: "",
			rules: {
	  nameRules: [v => !!v || "이름을 입력하세요.",
				  v => (/^[a-zA-Z0-9가-힣]+$/.test(v)) || "이름이 정확하지 않습니다.."

	  			],
      birthRules: [
        v => !!v || "생년월일을 입력하세요.",
        v => (v && v.length >= 8 && /((1|2)[0-9]{3})(0[1-9]{1}|1[0-2]{1})(0[1-9]|(1|2)[0-9]{1}|3[0-1]{1})$/.test(v)) || "생년월일이 정확하지 않습니다."
      ],
      cellTelNoRules: [
        v => !!v || "휴대폰번호를 입력하세요.",
        v =>
          (v &&
            v.length >= 11 &&
            /(01[0])([1-9]{1}[0-9]{2,3})([0-9]{4})$/.test(v)) ||
          "휴대폰번호가 정확하지 않습니다."
      ]
    }
		};
	},
	created() {
	},
	methods: {
		// 인즌번호 SMS 전송
		sendSmsCert(e) {
			this.gaTracking(e);

			this.valid = false;
			this.chkUserData();

			if(this.valid){
				this.certNum = "";
				this.progressDialog = true;
				this.axios
					.post(`${process.env.VUE_APP_KT_BM_API_URI}/rest/sendSmsCert`, {
						teleCoCd: this.teleCoCd,
						cellTelNo: this.cellTelNo,
						prdtNo: this.prdtNo,
						chanCd: this.chanCd,
					})
					.then(result => {
						this.progressDialog = false;
            // sgktbmapi 응답 처리 (resultCode 사용)
            if (result.data.resultCode === "S0000") {
              this.posts = result.data;
              this.countdowns("countdown", 3, 0);
              this.dialogHtmlText = "고객님의 휴대폰으로 인증번호가 <br />발송되었습니다.";
              this.dialogHtml = true;
            } else {
              this.dialogHtmlText = "잠시 뒤 다시 시도해주세요.";
              this.dialogHtml = true;
            }
					})
					.catch(result => {
						this.progressDialog = false;
						this.countdowns("countdown", 3, 0);
					});
			}
		},
		chkUserData(){
			this.valid = false;

			if(this.cellTelNo == null
				|| this.cellTelNo == ""
				){

				this.valid = false;
				this.dialog = true;
				this.dialogText = "휴대폰번호를 입력하세요.";
				return false;
			}
			if(this.cellTelNo.length != 11
				|| null == /(01[0])([1-9]{1}[0-9]{2,3})([0-9]{4})$/.exec(this.cellTelNo)
				){
				this.valid = false;
				this.dialog = true;
				this.dialogText = "휴대폰번호가 정확하지 않습니다.";
				return false;
			}
			this.valid = true;
		},
		chkForm() {
			if (this.certNum.length != 5) {
				this.valid = false;
				this.dialog = true;
				this.dialogText = "인증번호를 재확인 해주시기 바랍니다.";
				return false;
			}
			if (null == /([0-9]{5})$/.exec(this.certNum)) {
				this.valid = false;
				this.dialog = true;
				this.dialogText = "인증번호가 정확하지 않습니다.";
			}
			
		},
		submit(e) {
			this.gaTracking(e);

			this.valid = false;
			this.chkUserData();
			this.chkForm();

			if (!this.valid) {
				return false;
			}
			

			if(this.countdown === "0:00"){
				this.dialogHtmlText = "인증시간이 초과했습니다.<br/> 재전송 버튼을 눌러주시기 바랍니다.";
				this.dialogHtml = true;
				this.valid = false;
				this.progressDialog = false;
				return false;
			} 
			this.progressDialog = true;

			this.axios
				.post("/rest/chanCust", {
					type: this.type,
					teleCoCd: this.teleCoCd,
					cellTelNo: this.cellTelNo,
					certNum: this.certNum,
					prdtNo: this.prdtNo,
					chanCd: this.chanCd
				})
				.then(result => {
					this.progressDialog = false;
					if (result.data.resultCd === "S0000") {
						this.resultDialog = true;
						this.resultDialogText = "해지처리가 완료되었습니다.<br/><br/> 기타 문의사항은 고객센터 또는 help@finbridge.co.kr 로 문의 부탁드립니다."

						this.cellTelNo = "";
						this.certNum = "";
					} else if (result.data.resultCd === "E9990") {
						this.dialog = true;
						this.dialogText = "인증번호를 확인하세요.";
						this.certNum = "";
					} else if (result.data.resultCd === "E4209") {
						this.dialog = true;
						this.dialogText = "선택하신 서비스에 현재 정상적으로 <br />가입되어 있지 않습니다. <br />가입하신 서비스를 재확인하시고, <br />서비스 해지를 진행 부탁드립니다.<br><br>기타 문의사항은 고객센터 또는 <br />help@finbridge.co.kr로 <br />문의 부탁드립니다.";
						this.cellTelNo = "";
						this.certNum = "";
					} else if (result.data.resultCd === "E6011") {
						this.dialogHtmlText = "핀브릿지에서는<br/>보다 안정적인 서버운영을 위해서 <br/>매월 정기점검을 실시하고 있습니다. <br/><br/>점검 기간 동안 홈페이지 이용이 불가하오니,<br/>양해 부탁드립니다.<br/>감사합니다.";
						this.dialogHtml = true;
						this.cellTelNo = "";
						this.certNum = "";
					} else {
						this.dialogHtmlText = "선택하신 서비스에 현재 정상적으로 <br />가입되어 있지 않습니다. <br />가입하신 서비스를 재확인하시고, <br />서비스 해지를 진행 부탁드립니다.<br><br>기타 문의사항은 고객센터 또는 <br />help@finbridge.co.kr로 <br />문의 부탁드립니다.";
						this.dialogHtml = true;
						this.cellTelNo = "";
						this.certNum = "";
					}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
				})
				.catch(result => {
					this.progressDialog = false;
					this.dialogHtmlText = "선택하신 서비스에 현재 정상적으로 <br />가입되어 있지 않습니다. <br />가입하신 서비스를 재확인하시고, <br />서비스 해지를 진행 부탁드립니다.<br><br>기타 문의사항은 고객센터 또는 <br />help@finbridge.co.kr로 <br />문의 부탁드립니다.";
					this.dialogHtml = true;
				});
		},
		countdowns(elementName, minutes, seconds) {
			this.minutes = minutes;
			this.seconds = seconds;
			this.endTime =
				+new Date() + 1000 * (60 * this.minutes + this.seconds) + 500;
			this.updateTimer();
		},
		updateTimer() {
			this.msLeft = this.endTime - +new Date();
			if (this.msLeft < 1000) {
				this.countdown = "0:00";
			} else {
				this.time = new Date(this.msLeft);
				this.hours = this.time.getUTCHours();
				this.mins = this.time.getUTCMinutes();
				this.countdown =
				(this.hours
					? this.hours + ":" + this.twoDigits(this.mins)
					: this.mins) +
				":" +
				this.twoDigits(this.time.getUTCSeconds());
				setTimeout(this.updateTimer, this.time.getUTCMilliseconds() + 500);
			}
		},
		twoDigits(n) {
			return n <= 9 ? "0" + n : n;
		},
		goReturn(e){
			this.gaTracking(e);
			this.$router.go(-1);
			// this.resultDialog = false;
			// this.$router.push({name:this.backRouteName})
		},
		closePopup(e){
			this.gaTracking(e);

			this.resultDialog = false;
			this.dialog = false;
			this.dialogHtml = false;
		},
	},
};
</script>

<style scoped>
.cancelForm .inputBox {
	background-color: #fff;
	margin: 0px 18px 20px;
	padding: 15px 15px;
	position: relative;
	-webkit-box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.1);
	box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.1);
	overflow: hidden;
}
.cancelForm .inputBox p {
	text-align: center;
	font-size: 15px;
	color: #666;
	letter-spacing: -0.74px;
}
.cancelForm .inputBox .inputList {
	padding-top: 10px;
}
.cancelForm .inputBox .inputList > div {
	margin-bottom: 10px;
}
.cancelForm .inputBox .inputList > div input {
	background-color: #fff;
	display: block;
	border: 1px solid #e7e7e7;
	padding: 0 10px;
	height: 45px;
	line-height: 45px;
	width: 100%;
	font-size: 14px;
}
.cancelForm .inputBox .inputList > div input::placeholder {
	color: #bbb;
}
.cancelForm .inputBox .inputList > div input:focus {
	outline: 0;
}
.cancelForm .inputBox .inputList .genderSelect ul {
	overflow: hidden;
}
.cancelForm .inputBox .inputList .genderSelect ul li {
	float: left;
	margin-right: 10px;
}
.cancelForm .inputBox .inputList .genderSelect ul li span {
	display: block;
	border: 1px solid #e7e7e7;

	width: 45px;
	height: 45px;
	line-height: 43px;
	text-align: center;
	color: #666666;
	/* color: #ee1e2f; */
	font-size: 16px;
}
.cancelForm .inputBox .inputList .genderSelect ul li span.active {
	background-color: #ee1e2f;
	color: #fff;
}
.cancelForm .sendMsg {
	padding: 0 18px;
}
.cancelForm .sendMsg button {
	width: 100%;
	display: block;
	height: 50px;
	line-height: 50px;
	background-color: #2cbbb6;
	color: #fff;
	font-size: 17px;
	font-weight: bold;
}
.cancelForm .confirmInput {
	background-color: #fff;
	margin: 10px 18px 20px;
	padding: 15px 15px;
	position: relative;
	-webkit-box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.1);
	box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.1);
	overflow: hidden;
}

.cancelForm .confirmInput input {
	border: 1px solid #e7e7e7;
	height: 40px;
	line-height: 48px;
	padding: 0 10px;
	display: block;
	width: 100%;
	padding-right: 50px;
}
.cancelForm .confirmInput .inputWrap {
	position: relative;
}
.cancelForm .confirmInput .timer {
	position: absolute;
	right: 20px;
	top: 0;

	line-height: 34px;
}
.cancelForm .confirmInput .timer span {
	vertical-align: middle;
	display: inline-block;
	line-height: normal;
	font-size: 12px;
}

.cancelForm .btnArea {
	overflow: hidden;
	padding: 0 18px;
}
.cancelForm .btnArea .leftBox {
	float: left;
	width: 27%;
}
.cancelForm .btnArea .leftBox a {
	display: block;
	height: 60px;
	line-height: 60px;
	text-align: center;
	font-weight: bold;
	color: #fff;
	background-color: #809195;
	font-size: 18px;
}
.cancelForm .btnArea .rightBtn {
	float: right;
	width: 70%;
}
.cancelForm .btnArea .rightBtn button {
	background: #2cbbb6;
	display: block;
	width: 100%;
	font-size: 20px;
	height: 60px;
	line-height: 60px;
	text-align: center;
	font-weight: bold;
	color: #fff;
}

.infoText {
	padding: 10px 18px 40px;
}

.infoText p {
	color: #999999;
	font-size: 12px;
	letter-spacing: -0.74px;
}
</style>